import { createSelector } from "reselect";
import { RootState } from "../../store/rootStore";
import { IIntercomSelector } from "./intercom.interface";

const selectUserData = (state: RootState) => state.user;
const selectAuthData = (state: RootState) => state.authorization;

export const jivoSelector = createSelector(
  selectUserData,
  selectAuthData,
  (user, authorization) => {
    const loyaltyLevel = user?.loyalty?.level;
    const email = user.contacts.email;
    const phone = user.contacts.phone;
    const id = user.id;
    const auth = authorization.auth;
    const name = user.personalInfo
      ? user.personalInfo.name + " " + user.personalInfo.surname
      : `Client ${id}`;

    return {
      loyaltyLevel,
      email,
      phone,
      id,
      auth,
      name,
    } as IIntercomSelector;
  }
);
